module.exports = __webpack_public_path__ + "img/404.ed217cbd.webp";